module.exports = __webpack_public_path__ + "img/cargo.353926b7.svg";